export const SENSOR_LOGO_URL =
  "https://commons.wikimedia.org/wiki/Special:FilePath/TPMS_front_side.jpg?width=256";

export const LogoMark = ({ size = 40, className = "" }) => (
  <span
    className={`relative inline-flex shrink-0 items-center justify-center rounded-full overflow-hidden border-2 border-slate-400/50 bg-white shadow-[0_0_14px_rgba(230,57,70,0.25)] ${className}`}
    style={{ width: size, height: size }}
  >
    <img
      src={SENSOR_LOGO_URL}
      alt="حساس ضغط إطارات حقيقي TPMS"
      width={size}
      height={size}
      className="w-full h-full object-cover scale-[1.35]"
      loading="eager"
    />
    <span className="absolute -bottom-0.5 -left-0.5 w-2.5 h-2.5 rounded-full bg-red-600 border border-white/70" />
  </span>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark size={compact ? 32 : 40} />
    <span className="leading-tight">
      <span className="block font-display font-bold text-white text-base sm:text-lg">
        حساسات كفرات الرياض
      </span>
      {!compact && (
        <span className="block font-mono text-[10px] tracking-[0.2em] text-slate-500 uppercase">
          Riyadh Tire Sensors
        </span>
      )}
    </span>
  </span>
);
